var map = {
	"./scenario-0-assets/root101.png": "0ebc",
	"./scenario-1-assets/root101.png": "4ac4",
	"./scenario-2-assets/root101.png": "baa3",
	"./scenario-3-assets/root101.png": "6b20",
	"./scenario-4-assets/root101.png": "3eff"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5f29";
module.exports = webpackAsyncContext;